import { TransactionRequestDetails } from '@/types/transactionRequests';
import { SVSummaryCard } from '../core';
import { SVSummaryCardItem } from '@/types/common';
import { TRANSACTION_TYPE } from '@/types/transactions';
import { getTransactionReviewDeliverySpeed } from '@/utils/transactionReview';
import TransactionReviewAmount from '../transactionReview/TransactionReviewAmount';

type TransactionRequestInfoCardProps = {
  transactionRequestDetails: TransactionRequestDetails;
};

export default function TransactionRequestInfoCard({
  transactionRequestDetails,
}: TransactionRequestInfoCardProps) {
  const {
    fromAccount,
    toAccount,
    transactionType,
    displayAmount,
    deliverySpeed,
    note,
  } = transactionRequestDetails;

  function getTransactionType(transactionType: TRANSACTION_TYPE) {
    switch (transactionType) {
      case TRANSACTION_TYPE.InternalTransfer:
        return 'Internal Transfer';
      case TRANSACTION_TYPE.Withdrawal:
        return 'Withdrawal';
      case TRANSACTION_TYPE.Deposit:
        return 'Deposit';
      case TRANSACTION_TYPE.Wire:
        return 'Wire';
      default:
        return '';
    }
  }

  const items: SVSummaryCardItem[] = [
    {
      label: 'From Account',
      text: fromAccount,
    },
    {
      label: 'To Account',
      text: toAccount,
    },
    {
      label: 'Transaction Type',
      text: getTransactionType(transactionType),
    },
    {
      label: 'Amount',
      customContent: <TransactionReviewAmount amount={displayAmount} />,
    },
    {
      label: 'Speed',
      text: getTransactionReviewDeliverySpeed(deliverySpeed),
    },
    {
      label: 'Note',
      text: note,
    },
  ];

  return <SVSummaryCard label="Transaction Info" items={items} />;
}
